module.exports = __webpack_public_path__ + "static/media/res4.0a5f7176.png";